<template>
  <div class="payment-method-wrapper">
    <h2 class="payment-method-title">
      {{ $t('pages.billing.paymentMethod') }}
    </h2>

    <ib-card class="payment-method-card d-flex flex-column flex-sm-row justify-content-between align-sm-center" :animation="false">
      <div class="last-used-payment d-flex flex-column flex-sm-row align-sm-center">
        <p class="m-0 mb-2 mb-sm-0 font-outfit-regular">
          {{ $t('pages.billing.lastUsedPaymentMethod') }}
        </p>
        <template v-if="currentPaymentMethod">
          <div class="d-flex align-center">
            <img :src="currentPaymentMethod.icon" width="22" alt="payment-method-logo" class="mr-2">
            <span class="font-outfit-regular ">
              {{ currentPaymentMethod.name }}
            </span>
          </div>
        </template>
        <p v-else class="m-0 font-outfit-regular">
          {{ $t('pages.billing.none') }}
        </p>
      </div>
      <div>
        <div
          v-if="!subscriptionIsFreeTrial && userSubscription.update_url"
          class="billing-update-btn o-50 cursor-pointer font-outfit-medium"
          @click="onUpdateSubscription"
        >
          <i class="ib-icon-edit-2 ib-icon" /> {{ $t('pages.billing.update') }}
        </div>
      </div>
    </ib-card>

    <dialog-change-billing
      v-if="!subscriptionIsFreeTrial"
      :visible="dialogChangeBillingVisible"
      @close="dialogChangeBillingVisible = false"
    />
  </div>
</template>

<script>
import DialogChangeBilling from '@/views/Home/Components/Dialogs/DialogChangeBilling.vue'
import MixinPaddle from '@/mixins/paddle'
import UserSubscriptionMixin from '@/mixins/permissions/userSubscription'
import { mapGetters } from 'vuex'
import { paymentMethods } from '@/data/paymentMethods'

export default {
  name: 'PaymentMethod',

  components: { DialogChangeBilling },

  mixins: [UserSubscriptionMixin, MixinPaddle],

  data () {
    return {
      dialogChangeBillingVisible: false
    }
  },

  computed: {
    ...mapGetters('user/paymentHistory', ['getLastPayment']),
    ...mapGetters('user', ['getCurrentUser']),

    userSubscription () {
      return this.getCurrentUser.subscription
    },

    currentPaymentMethod () {
      if (!this.getLastPayment) return null

      return this.paymentMethodsOptions.find(method => method.type === this.getLastPayment.payment_method)
    },

    paymentMethodsOptions () {
      return paymentMethods
    }
  },

  created () {
    this.setupPaddle()
  },

  methods: {
    onUpdateSubscription () {
      // eslint-disable-next-line no-undef
      Paddle.Checkout.open({
        override: this.userSubscription.update_url,
        successCallback: () => {
          this.$notify({
            title: this.$t('pages.billing.success'),
            message: this.$t('pages.billing.yourPaymentMethodHasBeenUpdated'),
            type: 'success'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.payment-method-wrapper {
  .payment-method-title {
    font-size: 24px;
  }

  .payment-method-card {
    padding: 24px 34px 24px 29px;
    row-gap: 40px;

    .last-used-payment {
      column-gap: 35px;
    }

    .billing-update-btn {
      cursor: pointer;
      transition: all 0.25s ease;

      &:hover {
        opacity: 1;
        color: #292f4d;
      }
    }
  }
}
</style>
